import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        'primary': '#009688',
        'primary-text': '#212121',
        'secundary-text': '#757575',
        'divider': '#BDBDBD',
        'secondary': '#004A43',
        'accent': '#963000',
        'error': '#E57373',
        'info': '#4FC3F7',
        'greyLigth': '#757575',
        'success': '#66BB6A',
        'warning': '#FFA726'
      }
    }
  }
})
